import { render, staticRenderFns } from "./TextCapture.vue?vue&type=template&id=83876924"
import script from "./TextCapture.vue?vue&type=script&lang=js"
export * from "./TextCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports